<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.4865 27.7953C19.7728 28.0682 20.2272 28.0682 20.5135 27.7953L35.7751 13.2499C36.0682 12.9706 36.0758 12.5101 35.7922 12.2215C35.5086 11.9329 35.0411 11.9253 34.748 12.2047L20 26.2607L5.252 12.2047C4.95893 11.9253 4.49142 11.9329 4.2078 12.2215C3.92418 12.5101 3.93184 12.9706 4.22492 13.2499L19.4865 27.7953Z"
      class="fill-current"
    />
  </svg>
</template>
